// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IFilterSelectorSchema } from '../filter_selector/FilterSelectorSchema';
import type { IJsonQuerySchema } from '../json_query/JsonQuerySchema';
import type { IPromoSearchResultSchema } from '../promo_search_result/PromoSearchResultSchema';
import type { ISeoDataSchema } from '../seo_data/SeoDataSchema';
import type { ISortVariantSchema } from '../sort_variant/SortVariantSchema';
import type { ITagSchema } from '../tag/TagSchema';

export interface ISearchPromosResponseSchema {
  /** Текущая сортировка **/
  currentSortVariantType: ECurrentSortVariantType;
  /** Список фильтров-кнопок (чипсов) **/
  filterSelectors: IFilterSelectorSchema[];
  /** Является ли выдача подборкой **/
  isCompilation: boolean;
  /** Json query поискового запроса **/
  jsonQuery: IJsonQuerySchema;
  /** Найденные акции **/
  promoSearchResult: IPromoSearchResultSchema;
  /** Query string поискового запроса **/
  queryString: string;
  /** SEO данные **/
  seoData: ISeoDataSchema;
  /** Список возможных сортировок **/
  sortVariants: ISortVariantSchema[];
  /** Список тэгов **/
  tags: ITagSchema[];
}
export enum ECurrentSortVariantType {
  /** Заканчивается период действия **/
  'AboutToEnd' = 'aboutToEnd',
  /** Сначала новые **/
  'NewFirst' = 'newFirst',
  /** Популярные **/
  'Popularity' = 'popularity',
}
